const state = {
  options: [
    { label: '作者', value: 'createUser' },
    { label: '科室', value: 'questionDepart' },
    { label: '关键字', value: 'questionKey' },
    { label: '题目编号', value: 'questionCode' }
  ],
  // 题库一览搜索下拉条件
  questionOptions: [
    { label: '作者', value: 'createUser' },
    { label: '科室', value: 'questionDepart' },
    { label: '关键字', value: 'questionKey' },
    { label: '题目编号', value: 'questionCode' }
  ]
}
const mutations = {
  changeNeedcache (state, v) {
    state.needcache = v;
  }
}
const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/theory.js